import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ParticipanteService } from 'src/app/Services/participante.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Participante } from 'src/app/Models/participante.model';
import { ToastrService } from 'ngx-toastr';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { MunicipioService } from 'src/app/Services/municipio.service';
import { Municipio } from 'src/app/Models/municipio.model';
import { Observable } from 'rxjs';
import { Enumerador } from 'src/app/Models/enumerador.model';
import { EnumeradorService } from 'src/app/Services/enumerador.service';

@Component({
  selector: 'pre-cadastro',
  templateUrl: './pre-cadastro.component.html',
  styleUrls: ['./pre-cadastro.component.css']
})
export class PreCadastroComponent implements OnInit {

  formPreCadastro: FormGroup;
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  loading = false;
  @BlockUI() blockUI: NgBlockUI;
  municipios: Municipio[];
  racaCor: Observable<Enumerador[]>;
  sexo: Observable<Enumerador[]>;
  escolaridade: Observable<Enumerador[]>;
  data: string;
  dataValida = true;
  @Input() id: string;
  @Input() disabled;
  @Input() placeholder: string;

  constructor(private rota: Router, private fb: FormBuilder, private participanteService: ParticipanteService,
    private router: Router, private toast: ToastrService, private municipioService: MunicipioService,
    private enumeradorService: EnumeradorService) { }

  ngOnInit() {
    this.inicializarForm();
    this.carregarEnumeradores();
  }

  inicializarForm() {
    this.formPreCadastro = this.fb.group({
      nome: this.fb.control('', Validators.required),
      cpf: this.fb.control('', Validators.required),
      municipioid: this.fb.control('', Validators.required),
      email: this.fb.control('', [Validators.required, Validators.pattern(this.emailPattern)]),
      emailconfirmacao: this.fb.control('', [Validators.required, Validators.pattern(this.emailPattern)]),
      senha: this.fb.control('', Validators.required),
      senhaconfirmada: this.fb.control('', Validators.required),
      racacor: this.fb.control(''),
      genero: this.fb.control(''),
      datanascimento: this.fb.control('null'),
      escolaridade: this.fb.control('null')
    });

    this.municipioService.get().subscribe((response: any) => {
      if (response && response.data) {
        this.municipios = response.data;
      }
    });
  }

  carregarEnumeradores() {
    this.sexo = this.enumeradorService.get('ESexo');
    this.racaCor = this.enumeradorService.get('ERacaCor');
    this.escolaridade = this.enumeradorService.get('ENivelEscolaridade');
  }

  cadastrar(model: Participante) {
    model.pretendeparticiparoficinappa = null;
    model.desejareceberatualizacao = null;
    model.areatematicadebater = null;
    if (this.formPreCadastro.invalid) {
      this.toast.error('Preencha todos os campos do formulário corretamente.', 'Atenção', { enableHtml: true });
    }
    else if (this.formPreCadastro.value.email != this.formPreCadastro.value.emailconfirmacao) {
      this.toast.error('Campo E-mail e Confirmar E-mail são diferentes.', 'Atenção', { enableHtml: true });
    }
    else if (this.formPreCadastro.value.senha != this.formPreCadastro.value.senhaconfirmada) {
      this.toast.error('Campo Senha e Confirmar Senha são diferentes.', 'Atenção', { enableHtml: true });
    }
    else {

      this.blockUI.start('Aguarde...');
      this.participanteService.post(model)
        .subscribe(() => {

        }, (erroResponse: HttpErrorResponse) => {
          this.formPreCadastro.patchValue(model, { onlySelf: true });
          this.toast.error(erroResponse.error.message, 'Atenção', { enableHtml: true });
          this.blockUI.stop();
        },
        () => {
          setTimeout(() => {
            this.blockUI.stop();
            this.rota.navigate(['publico/login']);
            this.toast.success('Pré-Cadastro realizado com sucesso.', 'Atenção', { enableHtml: true });
          }, 2000);
        });
    }
  }

  voltar() {
    this.rota.navigate(['publico/login']);
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  onBlur() {
    if (this.data != null && !this.validarData()) {
      this.data = '';
      this.dataValida = false;
    } else {
      this.dataValida = true;

      var dataFinal = new Date();
      var dataInicial = new Date(this.data);
      var timeDiff = Math.abs(dataInicial.getTime() - dataFinal.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      this.formPreCadastro.patchValue({ 'idade': Math.round(diffDays / 365) });
    }

    this.propagateChange(this.data);
  }

  emitirData() {
    if (this.data.search('_') === -1) {
      if (!this.validarData()) {
        this.data = '';
      }
    }
    this.propagateChange(this.data);
  }

  validarData(): boolean {
    const [day, month, year] = this.data.split('/');

    const dia = Number(day);
    const mes = Number(month);
    const ano = Number(year);

    if (Number.isNaN(dia) || Number.isNaN(mes) || Number.isNaN(ano)) {
      return false;
    }

    if ((mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12)) {
      if ((dia >= 1) && (dia <= 31)) {
        return true;
      }
    }

    if ((mes === 4) || (mes === 6) || (mes === 9) || (mes === 11)) {
      if ((dia >= 1) && (dia <= 30)) {
        return true;
      }
    }

    if ((mes === 2)) {
      if ((ano % 4 === 0) && ((ano % 100 !== 0) || (ano % 400 === 0))) {
        if ((dia >= 1) && (dia <= 29)) {
          return true;
        }
      } else {
        if ((dia >= 1) && (dia <= 28)) {
          return true;
        }
      }
    }

    return false;
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.data = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  propagateChange = (_: any) => { };

  registerOnTouched(fn: any): void { }
}
